import React from 'react';
import { UseFormRegisterReturn } from 'react-hook-form-new';

interface CheckboxProps {
    id: string;
    label?: string;
    isChecked?: boolean;
    handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    click?: () => void;
    additionalClasses?: string;
    isDisabled?: boolean;
    reg?: UseFormRegisterReturn;
}

export const Checkbox = (props: CheckboxProps) => {
    const { id, isChecked, handleChange, additionalClasses, label, isDisabled, click, reg } = props;

    const classes = `checkbox ${additionalClasses ? additionalClasses : ''} ${isDisabled ? 'disabled' : ''}`;

    const preClick = () => {
        if (!isDisabled && click) {
            click();
        }
    };

    return (
        <div className={classes}>
            <input
                onClick={preClick}
                disabled={isDisabled}
                className="checkbox_control"
                type="checkbox"
                id={id}
                checked={isChecked}
                onChange={handleChange}
                {...reg}
            />
            <label className="checkbox_text" htmlFor={id}>
                {label && <span>{label}</span>}
            </label>
        </div>
    );
};
